/**
 * Kazakhstani tenge.
 */
export var KZT = {
  code: 'KZT',
  base: 10,
  exponent: 2
};